import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Menu from './Menu';
import NavBar from './NavBar';
import Loader from './Loader';
import { init } from "../store/actions/socket";

function Wrapper(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.account.token);
  const profile = useSelector((state) => state.account.profile);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (!token) {
      navigate('/login');
    } else {
      dispatch(init())
    }
  }, [token]);

  if (!token) {
    return null;
  }

  if (_.isEmpty(profile)) {
    return <Loader />;
  }

  return (
    <div id="wrapper">
      <Menu isShowing />
      <div className="container">
        <NavBar />
        <div className="mainContent">
          {props.children}
        </div>
      </div>
    </div>
  );
}

Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Wrapper;
